import styled from 'styled-components';
import { Layout } from 'antd';

const { Sider } = Layout;

export const StyledSider = styled(Sider)`
  border-right: 1px solid ${({ theme }) => theme.layoutBorderColor};

  .ant-btn {
    padding: 0 4px;
    height: 24px;
    width: 32px;
  }

  .ant-menu {
    border-inline-end: none !important;
  }

  .ant-menu-item {
    display: flex;
    align-items: center;
  }

  & .ant-menu-item .ant-menu-item-icon {
    height: 18px;
    width: 18px;
    min-width: 18px;
  }
`;
